import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageSquare, ThumbsUp, ThumbsDown, Minus } from "lucide-react";

interface ReportsStatsCardsProps {
  stats: {
    total?: number;
    positive?: number;
    negative?: number;
    noRating?: number;
  } | null;
}

export const ReportsStatsCards: React.FC<ReportsStatsCardsProps> = ({
  stats,
}) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="border-border/50 hover:border-border transition-colors">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Total Feedback
          </CardTitle>
          <MessageSquare className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold">{stats.total || 0}</div>
          <p className="text-xs text-muted-foreground mt-1">
            All feedback entries
          </p>
        </CardContent>
      </Card>
      <Card className="border-green-500/20 hover:border-green-500/30 transition-colors bg-green-500/5">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Positive
          </CardTitle>
          <ThumbsUp className="h-4 w-4 text-green-600" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-green-600">
            {stats.positive || 0}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            {stats.total
              ? `${Math.round(((stats.positive || 0) / stats.total) * 100)}% of total`
              : "—"}
          </p>
        </CardContent>
      </Card>
      <Card className="border-red-500/20 hover:border-red-500/30 transition-colors bg-red-500/5">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Negative
          </CardTitle>
          <ThumbsDown className="h-4 w-4 text-red-600" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-red-600">
            {stats.negative || 0}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            {stats.total
              ? `${Math.round(((stats.negative || 0) / stats.total) * 100)}% of total`
              : "—"}
          </p>
        </CardContent>
      </Card>
      <Card className="border-border/50 hover:border-border transition-colors">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            No Rating
          </CardTitle>
          <Minus className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-muted-foreground">
            {stats.noRating || 0}
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            {stats.total
              ? `${Math.round(((stats.noRating || 0) / stats.total) * 100)}% of total`
              : "—"}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

